import React from 'react';

import {
  DrawerHeader as ChakraDrawerHeader,
  forwardRef,
  useStyleConfig,
} from '@chakra-ui/react';

import { DrawerHeaderProps } from './types';

export const DrawerHeader = forwardRef<DrawerHeaderProps, 'header'>(
  (props, ref) => {
    const styles = useStyleConfig('DrawerHeader', { ...props });
    return <ChakraDrawerHeader ref={ref} sx={styles} {...props} />;
  }
);
